export default "__VITE_ASSET__BpvzQqY2__"